import { useState } from 'react';

export function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookie_consent'));
  if (!visible) return null;
  const accept = () => { localStorage.setItem('cookie_consent', '1'); setVisible(false); };
  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-4 left-4 z-[60] max-w-sm bg-surface-elevated border border-border shadow-xl p-5 fade-up">
      <p className="text-sm text-muted-foreground leading-relaxed mb-4">
        We use cookies to improve your experience and understand how our jewellery is discovered.
        By continuing to browse Ke-Sa, you accept our use of cookies.
      </p>
      <div className="flex items-center gap-3">
        <button data-testid="cookie-accept-button" onClick={accept}
          className="bg-gold text-primary-foreground px-5 py-2.5 text-xs font-mono uppercase tracking-widest hover:bg-gold-hover transition-colors">
          Accept
        </button>
        <a href="/faq" className="text-xs text-muted-foreground hover:text-gold underline underline-offset-4">Learn more</a>
      </div>
    </div>
  );
}
